import GuestGuard from '../auth/GuestGuard';
import {
  CompactLayout,
  LoginPage,
  LoginByToken,
  RegisterPage,
  VerifyCodePage,
  VerifyEmailPage,
  VerifyEmailCodePage,
  NewPasswordPage,
  ResetPasswordPage,
} from './elements';

export const authRoutes = {
  path: 'auth',
  children: [
    {
      path: 'login',
      element: (
        <GuestGuard>
          <LoginPage />
        </GuestGuard>
      ),
    },
    {
      path: 'login-by-token/:accesstoken',
      element: (
        <GuestGuard>
          <LoginByToken />
        </GuestGuard>
      ),
    },
    {
      path: 'register',
      element: (
        <GuestGuard>
          <RegisterPage />
        </GuestGuard>
      ),
    },
    { path: 'login-unprotected', element: <LoginPage /> },
    { path: 'register-unprotected', element: <RegisterPage /> },
    {
      element: <CompactLayout />,
      children: [
        { path: 'reset-password', element: <ResetPasswordPage /> },
        { path: 'new-password', element: <NewPasswordPage /> },
        { path: 'verify', element: <VerifyCodePage /> },
        { path: 'email_verify', element: <VerifyEmailPage /> },
        { path: 'email_verify_code', element: <VerifyEmailCodePage /> },
      ],
    },
  ],
};